<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$ = jQuery;
$(document).ready(function(){
  $('.collectionButton').click(function(){
    $('.collectionButton').removeClass('active');
    $(this).addClass('active');
    if($(this).hasClass('supplement_btn')){
      $('.supplementProducts').addClass('show');
      $('.packProducts').removeClass('show');
    }
    else if($(this).hasClass('pack_btn')){
      $('.packProducts').addClass('show');
      $('.supplementProducts').removeClass('show');
    }
  })
  
  
});

jQuery(document).ready(function() {
    setTimeout(function() {
    $('.gbbAddProductsPageFooterHTML .gbbProductsFooterHTML').prepend('<ul><li>+</li><li>+</li><li>+</li><li>+</li><li>+</li><li>+</li><li>+</li><li>+</li></ul>');
    }, 1000);
});

  var accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
//     console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
//       console.log(content.style.maxHeight);
    }
  };
});
  
//   $('div#originalsection div').each(function() {
//   var $div = $(this);
//     console.log(this);
//   var sectionclass = $div.attr('class').split(' ')[0];
//   $('#' + sectionclass).append($div);
// });

/**
* Cart Saver
*/

$(document).ready(function() {
  const form = $('#webform');
  const urlInput = $('input[name="Website"]', form);

  if (!urlInput) return;

  const url = new URL(window.location.href);
  const cartId = url?.searchParams?.get('cart');

  if (cartId && urlInput) {
    urlInput.val(window.location.origin + '/a/saved-carts/' + cartId);
    urlInput.attr('readonly', true);
  }
});

window.cartSaverCustom = {
  updateCartTitle: async function(id, title) {
    await fetch(`/a/saved-carts/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ title }),
    });
  }
};

